import React, { useState, useRef, useEffect } from "react";
import infoIcon from "../../../../assets/images/Icons/info_icon.svg";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../helpers/global_helper";
import { useSelector, useDispatch } from "react-redux";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import { formatPricewithdecimal, formatPrice } from "../../../NumberFormat";
import { withTranslation } from "react-i18next";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";

const ColokBebas2DVersiWap = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [showTooltip, setShowTooltip] = useState(false);
  const [betValues, setBetValues] = useState("");
  const [calculateTotal, setCalculateTotal] = useState({
    gameId: null,
    gameType: "colokbebas2d",
    fastbet: true,
  });
  const [RespCalculateTotal, setRespCalculateTotal] = useState({});
  const [reqSubmitData, setReqSubmitData] = useState({
    gameId: null,
    action: "process",
    gameType: "colokbebas2d",
    fastbet: true,
    dataangka: [],
    betTogelAuth: "betTogelAuth",
  });
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const betInputRef = useRef(null);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const handleInputChange = (e) => {
    setBetValues(e.target.value);
  };

  const handleClose = () => {
    setSuccessPopup(false);
    setSubmitRespData([]);
    allDataReset();
  };

  useEffect(() => {
    setCalculateTotal((prevReqData) => ({
      ...prevReqData,
      gameId: gameId,
      databet: betValues,
      multiple:betDiscount.showMultiple
    }));
  }, [betValues]);

  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitCalculateTotal = () => {
    if (!calculateTotal.databet) {
      setErrorMessage(props.t("format_input"));
      setShowErrorPopup(true);
      return;
    }

    let matchValidate = matchValidateVersi(gameType, calculateTotal.databet);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
        setErrorMessage(props.t(response.code));
        setShowErrorPopup(true);
        return;
      }
      setRespCalculateTotal(response.data);
      setTotalCountClick(true);
      const newAngakas = response.data.dataangka.map((item) => [
        item.nomor,
        item.taruhan,
        item.status,
      ]);
      setReqSubmitData((prevState) => ({
        ...prevState,
        gameId: gameId,
        dataangka: newAngakas,
      }));
    });
  };

  useEffect(() => {
    allDataReset();
  }, [gameId]);

  const allDataReset = () => {
    setTotalCountClick(false);
    setBetValues("");
    setRespCalculateTotal({});
    setCalculateTotal({
      gameId: null,
      gameType: "colokbebas2d",
      fastbet: true,
    });
    setReqSubmitData({
      gameId: null,
      action: "process",
      gameType: "colokbebas2d",
      fastbet: true,
      dataangka: [],
      betTogelAuth: "betTogelAuth",
    });
    if (betInputRef.current) betInputRef.current.value = "";
  };

  const submitProcess = () => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    } else {
      if (!calculateTotal.databet) {
        setErrorMessage(props.t("format_input"));
        setShowErrorPopup(true);
        return;
      }

      let matchValidate = matchValidateVersi(gameType, calculateTotal.databet);
      if (matchValidate) {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      }

      makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then(
        (response) => {
          if (response.status !== respStatus["SUCCESS"]) {
            if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
            setErrorMessage(props.t(response.code));
            setShowErrorPopup(true);
            return;
          }
          setRespCalculateTotal(response.data);
          const newAngakas = response.data.dataangka.map((item) => [
            item.nomor,
            item.taruhan,
            item.status,
          ]);
          setReqSubmitData((prevState) => ({
            ...prevState,
            gameId: gameId,
            dataangka: newAngakas,
          }));
          setShowConfirmationPopup(true);
        }
      );
    }
    // if (reqSubmitData.dataangka.length > 0) {
    //   setShowConfirmationPopup(true);
    // } else {
    //   setErrorMessage('Incorrect Input Format');
    //   setShowErrorPopup(true);
    // }
  };

  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, reqSubmitData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
        setErrorMessage(props.t(response.code));
        setShowErrorPopup(true);
        return;
      }
      allDataReset();
      setSubmitRespData((prevData) => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
    });
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>{props.t('guess_one_4d')}</p>
              <p>Format Tarun: BC*EH*HJ#bet+LM*PQ#bet</p>
              <p>Conoth Penulisan :12*30*50#1+48*60#2</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div className="versicontainer">
            <textarea
              rows="20"
              placeholder="12*30*50#1+48*60#2"
              ref={betInputRef}
              onChange={handleInputChange}
            ></textarea>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {RespCalculateTotal.line ? RespCalculateTotal.line : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {RespCalculateTotal.tover
                    ? formatPrice(RespCalculateTotal.tover)
                    : "-"}{" "}
                  &nbsp;
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total {props.t("discount")}</span>:{" "}
                  {RespCalculateTotal.disc
                    ? formatPrice(RespCalculateTotal.disc)
                    : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {RespCalculateTotal.pay
                    ? formatPrice(RespCalculateTotal.pay)
                    : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">
                        12*30*50#1+48*60#2
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={submitCalculateTotal}>
                  {props.t("count_total")}
                </button>
              </div>
              <div className="button_right">
                <button onClick={allDataReset}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={submitProcess}>{props.t('submit')}</button>
            </div>
          </div>
        </>
      )}
      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitProcessOk}
        />
      )}
      {successPopup && (
        <div className="popup-overlay ">
          <BetSuccessPopup
            response={SubmitRespData}
            onClose={() => handleClose(false)}
          />
        </div>
      )}
      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup
            message={errMessage}
            onClose={() => setShowErrorPopup(false)}
          />
        </ErrorInnerPopup>
      )}

      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
    </div>
  );
};

export default withTranslation()(ColokBebas2DVersiWap);
